import { makeStyles, Typography, IconButton, Paper } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    backgroundColor: 'white',
    borderRadius: 8,
    border: `1px solid ${theme.colors?.gray1 || '#D9D9D9'}`,
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
  },
  info: {
    flex: 1,
    minWidth: 0,
  },
  name: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.colors?.blue2 || '#122056',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  identifier: {
    fontSize: 12,
    color: theme.colors?.grey || '#8E8E8E',
    marginTop: 2,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  actionButton: {
    padding: 4,
    marginLeft: theme.spacing(1),
    flexShrink: 0,
  },
}));

const AccountListItem = ({
  businessName,
  customIdentifier,
  actionIcon,
  onAction,
  disabled = false,
  actionTooltip = '',
  actionClassName = '',
}) => {
  const classes = useStyles();

  return (
    <Paper className={classes.item} elevation={0}>
      <div className={classes.info}>
        <Typography className={classes.name}>
          {businessName || 'Unnamed Account'}
        </Typography>
        {customIdentifier && (
          <Typography className={classes.identifier}>
            ID: {customIdentifier}
          </Typography>
        )}
      </div>
      {actionIcon && (
        <IconButton
          className={`${classes.actionButton} ${actionClassName}`}
          onClick={onAction}
          disabled={disabled}
          size="small"
          title={actionTooltip}
        >
          {actionIcon}
        </IconButton>
      )}
    </Paper>
  );
};

export default AccountListItem;
